import { render, staticRenderFns } from "./CategoryMenuGroupSummary.vue?vue&type=template&id=5f648c14&scoped=true"
import script from "./CategoryMenuGroupSummary.vue?vue&type=script&lang=js"
export * from "./CategoryMenuGroupSummary.vue?vue&type=script&lang=js"
import style0 from "./CategoryMenuGroupSummary.vue?vue&type=style&index=0&id=5f648c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f648c14",
  null
  
)

export default component.exports